import { FormField } from "@avamae/formbuilder";
import { useField } from "formik";
import React, { useState } from "react";

type ExchangeRatesTableProps = {
  fieldName: string;
  label: string;
  readOnly?: boolean;
};

type ExchangeRateData = {
  fromCurrencyCode: string;
  toCurrencyCode: string;
  exchangeRate: number;
};

const ExchangeRatesTable: React.FC<ExchangeRatesTableProps> = ({
  fieldName,
  label,
  readOnly,
}) => {
  const [tableOpen, setTableOpen] = useState<boolean>(false);
  const [value, meta, helpers, ...rest] = useField<ExchangeRateData[]>(
    fieldName
  );

  return (
    <div className="ExchangeRatesTableContainer">
      {tableOpen && value && value.value && value.value.length > 0 && (
        <div className="ExchangeRatesTable">
          <div className="TableHeader Row">
            <div className="Column">
              <div className="Text">From currency code</div>
            </div>
            <div className="Column">
              <div className="Text">To currency code</div>
            </div>
            <div className="Column ExchangeRate">
              <div className="Text">Exchange Rate</div>
            </div>
          </div>

          {value.value.map(item => {
            return (
              <div className="Row">
                <div className="Column">
                  <div className="Text">{item.fromCurrencyCode}</div>
                </div>
                <div className="Column">
                  <div className="Text">{item.toCurrencyCode}</div>
                </div>
                <div className="Column ExchangeRate">
                  <div className="Text">{item.exchangeRate}</div>
                </div>
              </div>
            );
          })}
        </div>
      )}
      {tableOpen && (!value || !value?.value || value?.value.length === 0) && (
        <div className="NoData">
          <div className="Text">No Data</div>
        </div>
      )}

      <div
        className="ExhangeRatesTableExpandBtn Btn"
        onClick={() => {
          setTableOpen(!tableOpen);
        }}
      >
        {tableOpen ? "Close exchange rates table" : "Open exchange rates table"}
      </div>
    </div>
  );
};

export const exchangeRatesTableRenderer = (readOnly: boolean) =>
  function exchangeRatesTableRenderer<T>(
    _key: React.ReactText,
    field: FormField<T>
  ) {
    return (
      <ExchangeRatesTable
        label={field.label as string}
        readOnly={readOnly}
        fieldName={field.name as string}
      />
    );
  };
